import Vue from 'vue'
import Router from 'vue-router'
import env from '../utils/request/env.js'
Vue.use(Router)

export default new Router({
  mode: "history",
  // mode: "hash",
  // mode: env.getEnv() == '01' ? 'history' : 'hash',
  routes: [
    // { path: '/', redirect: '/fukuan/chepai/Index' },
    {
      path: '/fukuan/chepai/Index',
      component: () => import('@/views/plateCarNum/index.vue'),
      meta: { title: '停车缴费', keepAlive: false, }
    },
    {
      path: '/plateCarNum/carInputForWorker',
      component: () => import('@/views/plateCarNum/carInputForWorker.vue'),
      meta: { title: '车辆录入', keepAlive: false }
    },
    {
      path: '/fukuan/chepai/CheckOrder',
      component: () => import('@/views/order/CheckOrder.vue'),
      meta: { title: '停车缴费', keepAlive: false, }
    },
    {
      path: '/order/list',
      component: () => import('@/views/order/list.vue'),
      meta: { title: '我的订单', keepAlive: true }
    },
    {
      path: '/order/orderDetail',
      component: () => import('@/views/order/orderDetail.vue'),
      meta: { title: '订单详情', keepAlive: false }
    },
    {
      path: '/order/orderDetailFinish',
      component: () => import('@/views/order/orderDetailFinish.vue'),
      meta: { title: '订单详情', keepAlive: false }
    },
    {
      path: '/order/paySuccess',
      component: () => import('@/views/order/paySuccess.vue'),
      meta: { title: '支付成功', keepAlive: false }
    },
    {
      path: '/parking/parkingList',
      component: () => import('@/views/parking/parkingList.vue'),
      meta: { title: '停车场列表', keepAlive: false }
    },
    {
      path: '/plateCarNum/noNumCarIn',
      component: () => import('@/views/plateCarNum/noNumCarIn.vue'),
      meta: { title: '无牌车进场', keepAlive: false, }
    },
    {
      path: '/plateCarNum/noNumCarInResult',
      component: () => import('@/views/plateCarNum/noNumCarInResult.vue'),
      meta: { title: '无牌车进场', keepAlive: false, }
    },
    {
      path: '/nearbyBerth/index',
      component: () => import('@/views/nearbyBerth/index.vue'),
      meta: { title: '附近泊位', keepAlive: true, }
    },
    // 测试start
    {
      path: '/fukuan/chepai/IndexTest',
      component: () => import('@/views/plateCarNum/indexTest.vue'),
      meta: { title: '停车缴费', keepAlive: false, }
    },
    {
      path: '/order/orderDetailTest',
      component: () => import('@/views/order/orderDetailTest.vue'),
      meta: { title: '订单详情', keepAlive: false }
    },
    // 测试end

    // 振南停车场 start
    {
      path: '/index',
      component: () => import('@/views/plateCarNum/index_ronggui.vue'),
      meta: { title: '停车缴费', keepAlive: false, }
    },
    // 振南停车场 end



    // 月卡 start
    {
      path: '/monthCard/index',
      component: () => import('@/views/monthCard/index.vue'),
      meta: { title: '我的月卡', keepAlive: false, }
    },
    {
      path: '/monthCard/buyMonthCard',
      component: () => import('@/views/monthCard/buyMonthCard.vue'),
      meta: { title: '月卡购买', keepAlive: false, }
    },
    {
      path: '/monthCard/renewMonthCard',
      component: () => import('@/views/monthCard/renewMonthCard.vue'),
      meta: { title: '续卡', keepAlive: false, }
    },
    {
      path: '/monthCard/parkingMonthCard/index',
      component: () => import('@/views/monthCard/parkingMonthCard/index.vue'),
      meta: { title: '我的月卡', keepAlive: false, }
    },
    {
      path: '/monthCard/parkingMonthCard/buyMonthCard',
      component: () => import('@/views/monthCard/parkingMonthCard/buyMonthCard.vue'),
      meta: { title: '月卡购买', keepAlive: false, }
    },
    {
      path: '/monthCard/parkingMonthCard/renewMonthCard',
      component: () => import('@/views/monthCard/parkingMonthCard/renewMonthCard.vue'),
      meta: { title: '续卡', keepAlive: false, }
    },
    {
      path: '/monthCard/parkingMonthCard/refundMonthCard',
      component: () => import('@/views/monthCard/parkingMonthCard/refundMonthCard.vue'),
      meta: { title: '退卡', keepAlive: false, }
    },
    {
      path: '/monthCard/parkingMonthCard/changeMonthCard',
      component: () => import('@/views/monthCard/parkingMonthCard/changeMonthCard.vue'),
      meta: { title: '变更车牌', keepAlive: false, }
    },
    // 月卡 end


    // 商家系统========================start
    {
      path: '/parkingBusiness/register',
      component: () => import('@/views/parkingBusiness/register'),
      meta: { title: '申请加入', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/businessIndex',
      component: () => import('@/views/parkingBusiness/businessIndex'),
      meta: { title: '商家系统', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/businessLogin',
      component: () => import('@/views/parkingBusiness/businessLogin'),
      meta: { title: '商家登录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/forgetPassword',
      component: () => import('@/views/parkingBusiness/forgetPassword'),
      meta: { title: '忘记密码', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/accountList',
      name: 'home',
      component: () => import('@/views/parkingBusiness/accountList'),
      meta: { title: '账号列表', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/businessInfo',
      component: () => import('@/views/parkingBusiness/businessInfo'),
      meta: { title: '商家信息', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/accountManage',
      component: () => import('@/views/parkingBusiness/accountManage'),
      meta: { title: '账号管理', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/billManage',
      component: () => import('@/views/parkingBusiness/billManage'),
      meta: { title: '账单管理', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/plateInputDeduct',
      component: () => import('@/views/parkingBusiness/plateInputDeduct'),
      meta: { title: '商家优惠', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/home',
      component: () => import('@/views/parkingBusiness/home'),
      meta: { title: '商家系统', keepAlive: true, }
    },
    {
      path: '/parkingBusiness/businessRecharge',
      component: () => import('@/views/parkingBusiness/businessRecharge'),
      meta: { title: '商家充值', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/rechargeRecord',
      component: () => import('@/views/parkingBusiness/rechargeRecord'),
      meta: { title: '充值记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/useManage',
      component: () => import('@/views/parkingBusiness/useManage/useManage'),
      meta: { title: '使用记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/allUseRecord',
      component: () => import('@/views/parkingBusiness/useManage/allUseRecord'),
      meta: { title: '全部抵扣记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/timeUseRecord',
      component: () => import('@/views/parkingBusiness/useManage/timeUseRecord'),
      meta: { title: '时长抵扣记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/quantityUseRecord',
      component: () => import('@/views/parkingBusiness/useManage/quantityUseRecord'),
      meta: { title: '次数抵扣记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/fixedTimeUseRecord',
      component: () => import('@/views/parkingBusiness/useManage/fixedTimeUseRecord'),
      meta: { title: '固定时长次数抵扣记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/berthUseRecord',
      component: () => import('@/views/parkingBusiness/useManage/berthUseRecord'),
      meta: { title: '车位抵扣记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/totalTimeUseRecord',
      component: () => import('@/views/parkingBusiness/useManage/totalTimeUseRecord'),
      meta: { title: '累计时长抵扣记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/useManage/extraUseRecord',
      component: () => import('@/views/parkingBusiness/useManage/extraUseRecord'),
      meta: { title: '余额抵扣记录', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/plateInputSuccess',
      component: () => import('@/views/parkingBusiness/plateInputSuccess'),
      meta: { title: '抵扣成功', keepAlive: false, }
    },
    {
      path: '/parkingBusiness/visitingBusescar',
      component: () => import('@/views/parkingBusiness/visitingBusescar'),
      meta: { title: '访客车管理', keepAlive: false, }
    }, 
    // 商家系统========================end 


    // 寻车========================start
    {
      path: '/carSearch/index',
      component: () => import('@/views/carSearch/index'),
      meta: { title: '人民医院', keepAlive: false, }
    },
    {
      path: '/carSearch/carSearch',
      component: () => import('@/views/carSearch/carSearch'),
      meta: { title: '我要寻车', keepAlive: false, }
    },
    {
      path: '/carSearch/searchDetail',
      component: () => import('@/views/carSearch/searchDetail'),
      meta: { title: '位置信息', keepAlive: false, }
    },
    // 寻车========================end

    // 缴费========================start
    {
      path: '/parkingLot/plateInput',
      component: () => import('@/views/parkingLot/plateInput.vue'),
      meta: { title: '停车缴费', keepAlive: false, }
    },
    {
      path: '/parkingLot/orderDetail',
      component: () => import('@/views/parkingLot/orderDetail.vue'),
      meta: { title: '订单详情', keepAlive: false, }
    },
    {
      path: '/parkingLot/paySuccess',
      component: () => import('@/views/parkingLot/paySuccess.vue'),
      meta: { title: '支付成功', keepAlive: false }
    },
    {
      path: '/parkingLot/CheckOrder',
      component: () => import('@/views/parkingLot/CheckOrder.vue'),
      meta: { title: '停车缴费', keepAlive: false, }
    },
    {
      path: '/parkingLot/noNumCarIn',
      component: () => import('@/views/parkingLot/noNumCarIn.vue'),
      meta: { title: '无牌车进场', keepAlive: false, }
    },
    {
      path: '/parkingLot/noNumCarInResult',
      component: () => import('@/views/parkingLot/noNumCarInResult.vue'),
      meta: { title: '无牌车进场', keepAlive: false, }
    },
    // 缴费========================end
     
    //发票=========================start
    {
      path: '/fapiao/list',
      component: () => import('@/views/fapiao/list.vue'),
      meta: { title: '开具发票', keepAlive: false, }
    },
    {
      path: '/fapiao/apply',
      component: () => import('@/views/fapiao/apply.vue'),
      meta: { title: '订单开票', keepAlive: false, }
    },
    {
      path: '/fapiao/applyResult',
      component: () => import('@/views/fapiao/applyResult.vue'),
      meta: { title: '开具发票', keepAlive: false, }
    },
    {
      path: '/fapiao/addTitle',
      component: () => import('@/views/fapiao/add-title.vue'),
      meta: { title: '新增发票抬头', keepAlive: false, }
    },
    {
      path: '/fapiao/applyResult',
      component: () => import('@/views/fapiao/applyResult.vue'),
      meta: { title: '开具结果', keepAlive: false, }
    },
    {
      path: '/fapiao/record',
      component: () => import('@/views/fapiao/record.vue'),
      meta: { title: '订单开票记录', keepAlive: false, }
    },
    {
      path: '/fapiao/fapiaoDetail',
      component: () => import('@/views/fapiao/fapiao-detail.vue'),
      meta: { title: '订单发票详情', keepAlive: false, }
    },
    {
      path: '/fapiao/faPiaoOrderDetail',
      component: () => import('@/views/fapiao/faPiaoOrderDetail.vue'),
      meta: { title: '查看订单', keepAlive: false, }
    },
    {
      path: '/fapiao/chooseOrder',
      component: () => import('@/views/fapiao/choose-order.vue'),
      meta: { title: '订单开票', keepAlive: false, }
    },
    //发票=========================end
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js